"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentAuditClaimedDoseDtoManufacturerEnum = void 0;
exports.instanceOfDocumentAuditClaimedDoseDto = instanceOfDocumentAuditClaimedDoseDto;
exports.DocumentAuditClaimedDoseDtoFromJSON = DocumentAuditClaimedDoseDtoFromJSON;
exports.DocumentAuditClaimedDoseDtoFromJSONTyped = DocumentAuditClaimedDoseDtoFromJSONTyped;
exports.DocumentAuditClaimedDoseDtoToJSON = DocumentAuditClaimedDoseDtoToJSON;
exports.DocumentAuditClaimedDoseDtoToJSONTyped = DocumentAuditClaimedDoseDtoToJSONTyped;
/**
 * @export
 */
exports.DocumentAuditClaimedDoseDtoManufacturerEnum = {
    PfizerBiotech: 'PFIZER_BIOTECH',
    Moderna: 'MODERNA',
    JohnsonAndJohnson: 'JOHNSON_AND_JOHNSON',
    Novavax: 'NOVAVAX',
    Other: 'OTHER'
};
/**
 * Check if a given object implements the DocumentAuditClaimedDoseDto interface.
 */
function instanceOfDocumentAuditClaimedDoseDto(value) {
    if (!('date' in value) || value['date'] === undefined)
        return false;
    if (!('manufacturer' in value) || value['manufacturer'] === undefined)
        return false;
    return true;
}
function DocumentAuditClaimedDoseDtoFromJSON(json) {
    return DocumentAuditClaimedDoseDtoFromJSONTyped(json, false);
}
function DocumentAuditClaimedDoseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'date': json['date'],
        'manufacturer': json['manufacturer'],
    };
}
function DocumentAuditClaimedDoseDtoToJSON(json) {
    return DocumentAuditClaimedDoseDtoToJSONTyped(json, false);
}
function DocumentAuditClaimedDoseDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'date': value['date'],
        'manufacturer': value['manufacturer'],
    };
}
//# sourceMappingURL=DocumentAuditClaimedDoseDto.js.map